import type { PromptData, PromptVersion, PromptVersionDetail } from './types'
import api from '.'

export async function getPrompt(type?: string): Promise<PromptData> {
  const res = await api.get<PromptData>('/prompt', {
    params: type ? { type } : undefined,
  })
  return res.data
}

export async function getPromptVersion(
  id: number,
): Promise<PromptVersionDetail> {
  const res = await api.get<PromptVersionDetail>(`/prompt/${id}`)
  return res.data
}

export interface SavePromptPayload {
  name: string
  notes: string
  system_prompt: string
  type: string
}

export async function savePrompt(
  payload: SavePromptPayload,
): Promise<PromptVersion> {
  const res = await api.post<PromptVersion>('/prompt', payload)
  return res.data
}

export async function activateVersion(id: number): Promise<void> {
  await api.post(`/prompt/${id}/activate`)
}
